export default "__VITE_ASSET__BBlzE7$9__"